import React from "react";
import InfoAccordion from "./InfoAccordion";
import DetailField from "./DetailField";

export default function CustomerInformation({ singleOrder }) {
  const serviceArea = singleOrder?.customer_service_area;

  return (
    <InfoAccordion
      parentId="accordionContact"
      itemId="accordion-item-icon-right-1"
      title="Customer Information"
    >
      <div className="order_contact">
        <div className="d-flex">
          <div className="mr-4">
            <div className="alternative-image">
              {singleOrder?.customer_name?.charAt(0)}
            </div>
          </div>
          <div className="px-2 w-100">
            <div className="row">
              <DetailField
                label="Name:"
                value={singleOrder.customer_name}
                valueClassName="text-capitalize"
              />
              <DetailField label="Phone:" value={singleOrder.customer_phone} />
              <DetailField label="Email:" value={singleOrder.customer_email} />
              <DetailField
                label="Address:"
                value={singleOrder.customer_address}
              />
              <DetailField label="City:" value={singleOrder.customer_city} />
              <DetailField
                label="Gender:"
                value={singleOrder.customer_gender}
              />
            </div>

            {/* For orders that have service areas */}
            {serviceArea && (
              <div>
                <h5 className="font-weight-bold mb-4 mt-3">
                  Customer Service Area:
                </h5>
                <div className="row">
                  {[
                    ["Location:", serviceArea.area],
                    ["State:", serviceArea.state],
                    ["City:", serviceArea.city],
                    ["Zip Code:", serviceArea.zip],
                    ["Longitude:", serviceArea.longitude],
                    ["Latitude:", serviceArea.latitude],
                  ].map(([label, value]) => (
                    <DetailField
                      key={label}
                      label={label}
                      value={value}
                      valueClassName="text-capitalize"
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </InfoAccordion>
  );
}
